<snelstart-ui-details
        [config]="detailsConfig"
        [entityId]="id"
        title="Motivatie bezwaar {{this.getTitle()}}"
>
    <snelstart-ui-details-buttons>
        <snelstart-ui-button (click)="this.showDialogVerzenden(); this.checkCompletion()"
                             class="me-1"
                             icon="paper-plane"
                             type="primary"
        >Indienen
        </snelstart-ui-button>
        <snelstart-ui-button [config]="this.configSave(false)"
                             [disabled]="this.bezwaarEntity.submissionDate !== undefined"
                             class="me-1"
                             icon="check"
                             type="secondary"
        >Opslaan
        </snelstart-ui-button>
        <snelstart-ui-button (click)="this.showDialogAfdrukken();this.checkCompletion()"
                             class="me-1"
                             icon="file-pdf"
                             type="secondary"
        >Rapportage
        </snelstart-ui-button>
        <snelstart-ui-button (click)="this.showDialogGegevens()"
                             icon="file-lines"
                             type="secondary"
        >Gegevens
        </snelstart-ui-button>
    </snelstart-ui-details-buttons>

    <snelstart-ui-details-content>
        <snelstart-venture-fiscaal-bezwaar [id]="id"></snelstart-venture-fiscaal-bezwaar>

        <div class="file-upload">
            <input #fileUpload (change)="onFileSelected($event)" accept=".pdf" class="file-input" type="file">
            <div class="file-upload">
                <div class="password-container pt-1">
                    <snelstart-ui-button (click)="fileUpload.click()" class="upload-btn"
                                         icon="paperclip-vertical"
                                         type="secondary"
                    >
                        Voeg bijlage(n) toe
                    </snelstart-ui-button>
                </div>

                <div *ngFor="let bijlage of bezwaarEntity.bezwaarschrift?.bezwaarSpecificatie?.bijlagen; let i = index"
                     class="pt-1 ps-1">
                    Bijlage {{ i + 1 }}: {{ bijlage.filename }}
                    <snelstart-ui-icon
                            [name]="uploadSuccesvol ? 'check' : 'circle-x'"
                            [ngClass]="uploadSuccesvol ? 'check-button mx-1' : 'deadline-button mx-1'">
                    </snelstart-ui-icon>
                </div>
            </div>
        </div>
        <p class="pt-2 ps-1">
            <i *ngIf="getTotalBase64SizeInMB().valueOf() === 0">
                Alleen pdf-bestanden en totaal maximaal 15 Mb groot.
            </i>
            <i *ngIf="getTotalBase64SizeInMB().valueOf() > 0">
                Totale grootte: {{ getTotalBase64SizeInMB() | number :'1.2-2' }} Mb (max. 15Mb)
            </i>
            <br/>
        </p>
    </snelstart-ui-details-content>
</snelstart-ui-details>

<snelstart-ui-dialog-definition [(visible)]="dialogGegevensVisible" id="Gegevens" size="lg"
                                title="Gegevens bezwaar {{this.getTitle()}}">
    <snelstart-ui-dialog-body>
        <div [formGroup]="bezwaarschriftFg">
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            class="custom-input-250"
                                            formControlName="naamBelanghebbende"
                                            id="naamBelanghebbende"
                                            label="Naam belanghebbende"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-bsn-form-control [disabledControl]="true"
                                           class="custom-input-250"
                                           formControlName="bsnBelanghebbende"
                                           id="bsnBelanghebbende"
                                           label="Fiscaal nummer"
            >
            </snelstart-ui-bsn-form-control>
        </div>
        <div [formGroup]="bezwaarSpecificatieFg">
            <snelstart-ui-date-form-control (change)="this.checkCompletion(); this.saveForm()"
                                            [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                            [forceInvalidBorder]="this.isDagtekeningOuderDanZesWeken()"
                                            class="custom-input-250"
                                            formControlName="dagtekening"
                                            id="dagtekening"
                                            label="Dagtekening van de beschikking"
            >
            </snelstart-ui-date-form-control>
            <snelstart-ui-text-form-control (change)="this.checkCompletion(); this.saveForm()"
                                            [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                            class="custom-input-250"
                                            formControlName="aanslagnummer"
                                            id="aanslagnummer1"
                                            label="Aanslag-/Beschikkingsnummer"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-select-form-control (change)="this.checkCompletion(); this.saveForm()"
                                              [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                              [options]="optionsJaartal"
                                              class="custom-input-250"
                                              formControlName="aanslagJaar"
                                              id="aanslagJaar"
                                              label="Aanslagjaar"
            >
            </snelstart-ui-select-form-control>
            <div *ngIf="this.bezwaarSpecificatieFg.get('belastingMiddel')?.value === 'IH'">
                <snelstart-ui-select-form-control [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                                  [options]="this.optionsJaNee"
                                                  class="custom-input-250"
                                                  formControlName="bezwaarBox3"
                                                  id="bezwaarBox3"
                                                  label="Betreft bezwaar box 3"
                                                  (change)="this.saveForm()"

                >
                </snelstart-ui-select-form-control>
            </div>
            <div *ngIf="this.bezwaarSpecificatieFg.get('belastingMiddel')?.value === 'IH'">
                <snelstart-ui-select-form-control [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                                  [options]="this.optionsJaNee"
                                                  class="custom-input-250"
                                                  formControlName="bezwaarOndernemerschapIh"
                                                  id="bezwaarOndernemerschapIh"
                                                  (change)="this.saveForm()"
                                                  label="Betreft bezwaar ondernemerschap">
                </snelstart-ui-select-form-control>
            </div>
        </div>

        <p class="pt-2" style="font-weight: bold">Contactpersoon</p>

        <div [formGroup]="contactFg">
            <div class="d-flex gap-1 max-w-[250px]">
                <snelstart-ui-text-form-control [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                                class="custom-input-125"
                                                formControlName="voorletters"
                                                id="voorletters"
                                                label="Voorletter(s)"
                                                (change)="this.saveForm()"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control (change)="this.checkCompletion();"
                                                [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                                class="custom-input-115"
                                                formControlName="tussenvoegsel"
                                                id="tussenvoegsel"
                                                label="Tussenvoegsel(s)"
                                                (change)="this.saveForm()"
                >
                </snelstart-ui-text-form-control>
            </div>
            <snelstart-ui-text-form-control (change)="this.checkCompletion();"
                                            [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                            class="custom-input-250"
                                            formControlName="achternaam"
                                            id="achternaam"
                                            label="Achternaam"
                                            (change)="this.saveForm()"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-text-form-control (change)="this.checkCompletion(); "
                                            [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                            class="custom-input-250"
                                            formControlName="emailadres"
                                            id="e-mailadres"
                                            label="E-mailadres"
                                            (change)="this.saveForm()"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-text-form-control (change)="this.checkCompletion();"
                                            [disabledControl]="this.bezwaarEntity.submissionDate !== undefined"
                                            class="custom-input-250"
                                            formControlName="telefoonnummer"
                                            id="telefoonnummer"
                                            label="Telefoonnummer"
                                            (change)="this.saveForm()"
            >
            </snelstart-ui-text-form-control>
        </div>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button (click)="saveForm()" btn-x icon="check" id="save2" type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-ui-dialog-definition [(visible)]="dialogVerzendenVisible" id="lg" size="lg"
                                title="Indienen bezwaar {{this.getTitle()}}">
    <snelstart-ui-dialog-header-content>
        Klik op 'Nu indienen bezwaar' voor het verzenden van het bezwaar naar de Belastingdienst. <br/>Controleer altijd
        in het <b>Dossier {{ getDossier() }}</b> of er een bevestiging van indienen en een bevestiging van (succesvol)
        ontvangst getoond worden. Is dat niet het geval? Neem dan contact op met onze Klantenservice.
    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
        <div *ngIf="formComplete">
            <div [formGroup]="bezwaarschriftFg">
                <snelstart-ui-text-form-control [disabledControl]="true"
                                                class="custom-input-250"
                                                formControlName="naamBelanghebbende"
                                                id="naamBelanghebbendee"
                                                label="Naam belanghebbende"
                >
                </snelstart-ui-text-form-control>
            </div>
            <div [formGroup]="bezwaarSpecificatieFg">
                <snelstart-ui-text-form-control [disabledControl]="true"
                                                class="custom-input-250"
                                                formControlName="aanslagnummer"
                                                id="aanslagnummers"
                                                label="Aanslag-/Beschikkingsnummer"
                >
                </snelstart-ui-text-form-control>
            </div>
        </div>

        <div *ngIf="!formComplete">
            <snelstart-ui-alert type="warning">
                Er ontbreken nog gegevens in het bezwaar. Vul bij 'Gegevens' deze aan, daarna kan het bezwaar ingediend
                worden.
            </snelstart-ui-alert>
        </div>

    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel2"
                             type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button [config]="buttonConfig" [disabled]="!formComplete" icon="check" id="saveBezwaar"
                             type="primary">Nu indienen
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-ui-dialog-definition [(visible)]="this.dialogAfdrukkenVisible" id="id" size="lg"
                                title="Rapportage bezwaar {{this.getTitle()}}">
    <snelstart-ui-dialog-header-content>
        Het (concept) rapport komt als pdf beschikbaar. Dit is een rapport ter controle en/of voor eigen gebruik. Voor
        het bekijken van een daadwerkelijk bij de Belastingdienst ingediend bezwaar ga je terug naar het 'Dossier' en
        klik je op het betreffende bericht. Ook in het Dossier van het betreffende jaar vind je een daadwerkelijk
        verzonden
        bezwaar.
    </snelstart-ui-dialog-header-content>

    <snelstart-ui-dialog-body>
        <div *ngIf="!formComplete">
            <snelstart-ui-alert type="warning">
                Er ontbreken nog gegevens in het bezwaar. Vul bij 'Gegevens' deze aan, daarna is het bezwaar als pdf
                beschikbaar.
            </snelstart-ui-alert>
        </div>

        <div *ngIf="formComplete">
            <div [formGroup]="bezwaarschriftFg">
                <snelstart-ui-text-form-control [disabledControl]="true"
                                                class="custom-input-250"
                                                formControlName="naamBelanghebbende"
                                                id="dienst"
                                                label="Naam belanghebbende"
                >
                </snelstart-ui-text-form-control>
            </div>
            <div [formGroup]="bezwaarSpecificatieFg">

                <snelstart-ui-text-form-control [disabledControl]="true"
                                                class="custom-input-250"
                                                formControlName="aanslagnummer"
                                                id="aanslagnummer"
                                                label="Aanslag-/Beschikkingsnummer"
                >
                </snelstart-ui-text-form-control>
            </div>
        </div>
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                             type="secondary">
            Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button (click)="this.createPdf()" [config]="afdrukkenButtonConfig" [disabled]="!this.formComplete"
                             icon="check" id="save" type="primary">
            Genereer rapport
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
